// @flow
import { createAction } from 'redux-actions';

import type { ActionType } from 'types/redux';
import type { IAddress } from './IAddress';

export const SET_ADDRESS = 'appointment/contactInfo/SET_ADDRESS';
export const setAddress = createAction(
  SET_ADDRESS,
  (address: IAddress) => address
);

export const SET_STREET_ADDRESS_ONE =
  'appointment/contactInfo/SET_STREET_ADDRESS_ONE';
export const setStreetAddressOne = createAction(
  SET_STREET_ADDRESS_ONE,
  streetAddressOne => streetAddressOne
);

export const SET_STREET_ADDRESS_TWO =
  'appointment/contactInfo/SET_STREET_ADDRESS_TWO';
export const setStreetAddressTwo = createAction(
  SET_STREET_ADDRESS_TWO,
  streetAddressTwo => streetAddressTwo
);

export const SET_CITY = 'appointment/contactInfo/SET_CITY';
export const setCity = createAction(SET_CITY, city => city);

export const SET_STATE_ADDRESS = 'appointment/contactInfo/SET_STATE_ADDRESS';
export const setStateAddress = createAction(SET_STATE_ADDRESS, state => state);

export const SET_POSTAL_CODE = 'appointment/contactInfo/SET_POSTAL_CODE';
export const setPostalCode = createAction(
  SET_POSTAL_CODE,
  postalCode => postalCode
);

export const SET_COUNTRY = 'appointment/contactInfo/SET_COUNTRY';
export const setCountry = createAction(SET_COUNTRY, country => country);

export type Action =
  | ActionType<typeof setAddress>
  | ActionType<typeof setStreetAddressOne>
  | ActionType<typeof setStreetAddressTwo>
  | ActionType<typeof setCity>
  | ActionType<typeof setStateAddress>
  | ActionType<typeof setPostalCode>
  | ActionType<typeof setCountry>;



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/contactInfo/address/actions.js